import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import CreatingKidPage from './CreatingKidPage';

const CreatingKidPageRoute: FuseRouteItemType = {
  path: '',
  element: <CreatingKidPage />,
};

export default CreatingKidPageRoute;
